import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings/settings.component';
import {AgmCoreModule} from "@agm/core";
import {SettingsDattaService} from "@app/features/settings/settings.service";
import {FormsModule} from "@angular/forms";
import {NgxSpinnerModule} from "ngx-spinner";
import {SharedModule} from "@shared/shared.module";


@NgModule({
  declarations: [
    SettingsComponent
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    AgmCoreModule,
    FormsModule,
    NgxSpinnerModule,
    SharedModule
  ],
  providers:[
    {provide: SettingsDattaService,
    useClass:SettingsDattaService }

  ]
})
export class SettingsModule { }
